import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

const QRCode = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center">
      <p className="text-xs text-gray-400 mb-2">{t('footer.wechatQR')}</p>
      <img
        src="https://bigshowcdn.cmcm.com/upload/image/20241224/U37EuQ4s022980.png"
        alt={t('footer.qrCodeAlt')}
        className="w-40 h-40 object-contain"
      />
    </div>
  );
}

export default QRCode;